"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _StagedObject = _interopRequireDefault(require("redux-less/StagedObject"));

var _constants = require("settings-ui-sdk/DoiSettings/constants");

var _selectors = require("settings-ui-sdk/DoiSettings/selectors");

var properties = [_constants.ENABLED, _constants.WELCOME_EMAIL_ENABLED];

var _default = new _StagedObject.default({
  domainSelector: _selectors.getDoiSettings,
  stagedSelector: function stagedSelector(state) {
    return state.modules.marketing.email.staging.updateDoiSettings;
  },
  namespace: 'email',
  objectType: _constants.DOI_SETTINGS,
  properties: properties
});

exports.default = _default;
module.exports = exports.default;